import {
	booleanAttribute,
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { pluck } from "@app/services/api.service"
import { Modalable } from "@app/Modalable"
import { defaultEmptyString } from "@app/helpers"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { BtnExtComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-otp",
	imports: [COMMON_IMPORTS, LangValPipe, GenInputComponent, BtnExtComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./otp.component.html",
})
export class OtpComponent extends Modalable {
	error: boolean = false //hold whether or not an invalid code returned
	apiResponseWasSuccess: boolean = false //hold whether or not api responded with success (i.e. otp code was valid)
	otp_token: string = "" //changed by user and sent to api
	@Input({ transform: defaultEmptyString }) token: string = "" //token received from url (send to api)
	@Input() mode: "regi" | "otp" | "sub_user_regi" | "potential_user_regi" =
		"otp" //flag for being part of regi process. affects the api function's url
	isSending: boolean = false //while waiting for the api to return (controls send btn disabled and outputs a "waiting" gif)
	@Input({ transform: booleanAttribute }) is2faApp: boolean = false

	ngOnInit() {
		this.requestOTPAutoFill()
	}

	preSubmit(ev: KeyboardEvent) {
		if (["Tab", "Enter"].includes(ev.key)) {
			this.submit()
		}
	}
	async submit() {
		//send otp to api
		if (this.isSending) {
			return
		} //is curently waiting for api return - exit
		this.isSending = true //flag "waiting for the api to return" as true
		let funcName: string = "send_otp"
		switch (this.mode) {
			case "regi":
				funcName = "register/otp"
				break
			case "sub_user_regi":
				funcName = "sub_user_otp"
				break
			case "potential_user_regi":
				funcName = "potential_user_otp"
				break
		}
		this.error = false //reset error display to false

		this.apiResponseWasSuccess = true
		const res = await this.apiService.post(funcName, {
			otp_token: this.otp_token,
			token: this.token,
		})
		if (res.success) {
			// this.modalService.openToast("confirmation_successful_please_login_to_continue");
			this.onClose.emit(res)
		} else {
			this.isSending = false //flag "waiting for the api to return" as false
			this.apiResponseWasSuccess = false
			this.error = true //make sure error IS displayed
			this.modalService.openToast(res.error || "code_is_not_valid") //failed - toast failure to the user
		}
	}

	async requestOTPAutoFill() {
		if (!("OTPCredential" in window)) {
			console.log("WebOTP not supported")
			return null
		}

		try {
			const credential: any = await (navigator as any).credentials.get({
				otp: { transport: ["sms"] },
			})

			if (credential?.code) {
				this.otp_token = credential.code
				this.submit()
			}
		} catch (error: any) {
			if (error.name === "AbortError") {
				console.log("OTP request timed out")
			} else {
				console.log("OTP request failed:", error)
			}
			return null
		}
	}
}
